export default __webpack_public_path__ + "508a2d8ec65a57b3e20ead53d0d61281.svg";